import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, map } from 'rxjs';
import { environment } from 'src/environments/environment';

export class DeptBookItem {
    DepartmentCode: string;
    City: string;
    Country: string;
    Name: string;
    OfficeAddress: string;
    Phone: string;
    DepartmentHomePage: string;
    CanSendPassportByMail: boolean;
    OnlineQueueURL: string;
    Email: string;
    ZPAnnouncement?: string;
    Closed: boolean;
}

export class Department {
    code: string;
    city: string;
    country: string;
    closed: boolean;
    name: string;
    officeAddress: string | null;
    phone: string | null;
    website: string | null;
    onlineQueueURL: string | null;
    canSendPassportByMail: boolean;
    announcement: string | undefined;
}

export abstract class DeptBookService {
    abstract list(): Observable<Department[]>;
}

@Injectable()
export class HttpDeptBookService implements DeptBookService {
    constructor(private http: HttpClient) {}

    list(): Observable<Department[]> {
        const url = `${environment.api}/deptbook/departments`;
        return this.http.get<DeptBookItem[]>(url).pipe(
            map((list) => list.map((dto) => this.toDepartment(dto)))
        );
    }

    private toDepartment(dto: DeptBookItem): Department {
        const department = new Department();

        department.code = dto.DepartmentCode;
        department.city = dto.City;
        department.country = dto.Country;
        department.name = dto.Name;
        department.officeAddress = dto.OfficeAddress;
        department.phone = dto.Phone;
        department.website = dto.DepartmentHomePage;
        department.onlineQueueURL = dto.OnlineQueueURL;
        department.canSendPassportByMail = dto.CanSendPassportByMail;
        department.closed = dto.Closed;
        department.announcement = dto.ZPAnnouncement;

        return department;
    }
}
